
import {empty as observableEmpty, of as observableOf,  Observable } from 'rxjs';

import {mergeMap,  flatMap } from 'rxjs/operators';
import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { MatSnackBar,MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { AppService } from '../commons/app.service';
import { AppRoutes } from '../commons/global';
import { TranslateService } from '@ngx-translate/core'
import { FourDService } from '4d-mapper';
import {BaseComponent} from '../commons/BaseComponent';

import { XsApplicationEventsService } from '../xs/services/events/application-events.service';
import { LoadingSpinner } from '../commons/ui/loading-spinner';

@Component({
    selector: 'forget-comp',
    templateUrl: './forget.component.html',
    styleUrls: ['./auth.component.scss']
})
export class ForgetComponent  extends BaseComponent {

  
    pass2:string = ""
    error:any
    loading =true
    user:string
    tok:string 
    constructor(public service:AppService, public router:Router,private ar:ActivatedRoute,public location:Location, public snackBar: MatSnackBar, 
        public dialog: MatDialog, public translate: TranslateService, applicationEvents:XsApplicationEventsService){
        super(router, snackBar, dialog)
        this.openEdgeWarningDialog();
        this.service.V.config.clientId = '4dmapper'
      
        ar.params.subscribe(p => {
            this.tok = p.tok
           this.service.V.api('/access/forget/' + this.tok).subscribe(s => {
               this.user = s
            this.loading = false;
            LoadingSpinner.end();
           },e => {
               this.loading = false;
               LoadingSpinner.end();
               this.error = e
           })
        })

    }
    resetPass(){
        this.service.V.api('/access/forget/' + this.tok,'put',this.user).subscribe(s => {
            this.openDialog('SIGNIN.FORGOT_OK').subscribe(s => this.router.navigate(['/auth']))
        },e => this.openDialog('GENERIC.ERROR',e.message)
        )
    }
}
